import React, { useEffect, useState } from "react";
import { Button, SelectField } from "components/form";
import _, { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";
import Cards from "assets/images/svg/cards_via_fawry.svg";
import CreditFull from "assets/images/svg/credit_full.svg";
import FawryFull from "assets/images/svg/fawry_full.svg";
import PayoalFull from "assets/images/svg/payoal_full.svg";

import { MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCardsToken } from "hooks/use-pay-method";
import { useAuthContext } from "store/auth";
import { useNavigate } from "react-router-dom";
import { json, showDiscriminate } from "helpers/data";
import { buildChargeRequest } from "helpers/fawry";
import { client } from "helpers/client";
import PaymentApproved from "./paymentApproved";
import PaymentFailed from "./paymentFailed";

const PaymentForm = ({ data, appPayDetails, onBill, defaultBill, isLoading, InvoiceId, ...props }) => {
  const navigate = useNavigate();

  const { t } = useTranslation("browse-apps");
  //todo: remove
  const { cards } = useCardsToken();
  const { reset } = useFormContext();
  const [{ user, token }] = useAuthContext();

  const [fawryWay, setFawryWay] = useState("cash");

  const paypalObj = data?.find((p) => p?.paymentType?.name === "Paypal") ?? {};
  const fawrylObj = data?.find((p) => p?.paymentType?.name === "Fawry") ?? {};
  const visaObj = data?.find((p) => p?.paymentType?.name === "Visa") ?? {};
  const defaultObj = data?.find((p) => p?.isDefault === true).id ?? "";
  const countryFawryId = data?.find((p) => p?.paymentType?.name === "Fawry")?.countryPayment?.id ?? "";

  const [pay, setPay] = useState(defaultObj);
  const [payWithFawryCard, setPayWithFawryCard] = useState(false);
  const [fawryCardLoading, setFawryCardLoading] = useState(false);

  const defaultFawryCard = cards.filter((c) => c.isDefault).map((e) => e.cardToken)[0];

  //price
  let forever = appPayDetails?.versionPrice?.forever;
  let monthly = appPayDetails?.versionPrice?.monthly;
  let yearly = appPayDetails?.versionPrice?.yearly;

  const [success, setSuccess] = useState({
    server: null,
    fawry: null
  });

  useEffect(() => {
    const PayData = {
      paymentMethodId: isEmpty(pay) ? defaultObj : pay,
      bill: defaultBill,
      fawryWay: fawryWay,
      card_id: defaultFawryCard
    };
    reset(PayData);
  }, [defaultBill, data.id, defaultObj, pay, reset, fawryWay, defaultFawryCard]);

  const handlePay = (e) => {
    const value = e.target.value;
    setPay(e.target.value);
  };
  const handleFawryWay = (e) => {
    setFawryWay(e.target.value);
  };

  function successCallBack(data) {
    setSuccess((prev) => ({
      server: null,
      fawry: true
    }));

    client("/Invoice/Fawry/CallBackThreeDSecureUrl", {
      method: "GET",
      params: {
        ...data,
        customerMail: user?.email,
        customerMobile: user?.Mobile
      }
    })
      .then(() => {
        setSuccess((prev) => ({
          ...prev,
          server: true
        }));
      })
      .catch(() => {
        setSuccess((prev) => ({
          ...prev,
          server: false
        }));
      })
      .finally(() => {
        // setPayWithFawryCard(false);
        setFawryCardLoading(false);
      });
  }
  function failureCallBack(data) {
    console.log(data);
    setSuccess({
      fawry: false,
      server: null
    });
    // setPayWithFawryCard(false);
    setFawryCardLoading(false);
  }

  return (
    <>
      {fawryCardLoading  && <div className="card-loader"></div>}

      {success.fawry && (success.server || success.server === false) && (
        <PaymentApproved
          show={true}
          data={appPayDetails}
          onHide={() => {
            setSuccess({
              fawry: null,
              server: null
            });
          }}
        />
      )}

      {success.fawry === false && (
        <PaymentFailed
          show={true}
          onHide={() => {
            setSuccess({
              fawry: null,
              server: null
            });
          }}
        />
      )}

      {_.isEmpty(InvoiceId) && (
        <div className="row" onChange={(e) => onBill(e.target.value)}>
          {appPayDetails?.subscriptionTypeId !== 1 ? (
            <>
              <div className="col-md-6">
                <label className="bill-radio ">
                  <input type="radio" name="bill" id="monthly" value="Monthly" defaultChecked={defaultBill === "Monthly"} />
                  <span className="border-color span">
                    <h2>{t("pricingPlan.billMonthly")}</h2>
                    <div className="price">
                      <h3>
                        {monthly?.netPrice} <span className="curacy">{json(`${yearly?.currencySymbol}`)}</span>{" "}
                        <span className="month">/ {json(`${showDiscriminate(`${monthly?.discrimination}`)}`)}</span>
                      </h3>
                      {monthly?.discountPercentage > 0 && <span className="badgee">{monthly?.discountPercentage}% Off</span>}
                    </div>
                  </span>
                </label>
              </div>
              <div className="col-md-6">
                <label className="bill-radio">
                  <input type="radio" name="bill" id="yearly" value="Yearly" defaultChecked={defaultBill === "Yearly"} />
                  <span className="border-color span">
                    <h2>{t("pricingPlan.billYearly")}</h2>
                    <div className="price">
                      <h3>
                        {yearly?.netPrice} <span className="curacy">{json(`${yearly?.currencySymbol}`)}</span>{" "}
                        <span className="month">/ {json(`${showDiscriminate(`${yearly?.discrimination}`)}`)}</span>
                      </h3>
                      {yearly?.discountPercentage > 0 && <span className="badgee">{yearly?.discountPercentage}% Off</span>}
                    </div>
                  </span>
                </label>
              </div>
            </>
          ) : (
            <>
              {/* <div className="col-md-6">
              <label className="bill-radio">
                <input type="radio" name="bill" id="yearly" value="Yearly"   defaultChecked={appPayDetails?.subscriptionTypeId === 1} />
                <span className="border-color span">
                  <h2>Bill yearly</h2>
                  <div className="price">
                    <h3>
                      109.99 <span className="curacy">SAR</span> <span className="month">/ per month</span>
                    </h3>
                    <span className="badgee">33% Off</span>
                  </div>
                </span>
              </label>
            </div> */}
              <div className="col-md-6">
                <label className="bill-radio ">
                  <input type="radio" name="bill" id="forever" value="Forever" defaultChecked={defaultBill === "Forever"} />
                  <span className="border-color span">
                    <h2>{t("pricingPlan.billForever")}</h2>
                    <div className="price">
                      <h3>
                        {forever?.netPrice}{" "}
                        <span className="curacy">{json(`${showDiscriminate(`${forever?.discrimination}`)}`)}</span>{" "}
                        <span className="month">/ {json(`${showDiscriminate(`${forever?.discrimination}`)}`)}</span>
                      </h3>
                      {forever?.discountPercentage > 0 && <span className="badgee">{forever?.discountPercentage}% Off</span>}
                    </div>
                  </span>
                </label>
              </div>
            </>
          )}
        </div>
      )}

      <h2 className="pay">{t("paymentDetails.paymentMessage.payWith")}:</h2>
      <div className="row" onChange={handlePay}>
        {!_.isEmpty(paypalObj) && (
          <div className="col-md-4">
            <label className="bill-radio pay-radio">
              <input type="radio" name="pay" id="paypal" value={paypalObj.id} defaultChecked={paypalObj.isDefault} />
              <span className="border-color span">
                <img src={PayoalFull} alt="" />
              </span>
            </label>
          </div>
        )}

        {!_.isEmpty(visaObj) && (
          <div className="col-md-4">
            <label className="bill-radio pay-radio">
              <input type="radio" name="pay" id="visa" value={visaObj.id} defaultChecked={visaObj.isDefault} />
              <span className="border-color span">
                <img src={CreditFull} alt="" />
              </span>
            </label>
          </div>
        )}

        {!_.isEmpty(fawrylObj) && (parseInt(user?.CountryId) === countryFawryId || countryFawryId === 0) && (
          <div className="col-md-4">
            <label className="bill-radio pay-radio">
              <input type="radio" name="pay" id="fawry" value={fawrylObj.id} defaultChecked={fawrylObj.isDefault} />
              <span className="border-color span">
                <img src={FawryFull} alt="" />
              </span>
            </label>
          </div>
        )}
      </div>

      {parseInt(pay) === fawrylObj.id && (parseInt(user?.CountryId) === countryFawryId || countryFawryId === 0) && (
        <div onChange={handleFawryWay}>
          <label className="bill-radio mb-3">
            <input type="radio" name="fawryWay" id="cash" value="cash" defaultChecked={true} />
            <span className="border-color span">
              <h2> {t("paymentDetails.paymentMessage.byCash")}</h2>
              <div className="price">
                <h3 className="dimmed"> {t("paymentDetails.paymentMessage.cashMsg")}</h3>
              </div>
            </span>
          </label>

          <label className="bill-radio mb-3" onClick={() => setPayWithFawryCard(true)}>
            <input type="radio" name="fawryWay" id="card" value="card" />
            <span className="border-color span">
              <h2> {t("paymentDetails.paymentMessage.byCard")}</h2>
              <div className="price">
                <img src={Cards} alt="Cards" />
              </div>
            </span>
          </label>
        </div>
      )}

      {/* {fawryWay === "card" && parseInt(pay) === fawrylObj.id && (
        <SelectField label={t("paymentDetails.pleaseSelectCard")} id="card_id" rules={{ required: "errors:required" }}>
          {cards?.map((option) => (
            <MenuItem key={option.id} value={option?.cardToken}>
              {option?.extraInfo} - {option?.cardNumber}
            </MenuItem>
          ))}
          <MenuItem value="add" className="btn-blue-light" onClick={() => navigate("/paymentSetting")}>
            {t("paymentDetails.cardForm.add")}
          </MenuItem>
        </SelectField>
      )} */}

      {(!_.isEmpty(visaObj) ||
        !_.isEmpty(paypalObj) ||
        (!_.isEmpty(fawrylObj) && (parseInt(user?.CountryId) === countryFawryId || countryFawryId === 0))) && (
        <Button
          type="submit"
          className="btn-blue "
          isLoading={isLoading || fawryCardLoading}
          onClick={() => {
            if (payWithFawryCard) {
              setFawryCardLoading(true);
              buildChargeRequest(user, appPayDetails, successCallBack, failureCallBack);
            }
          }}
        >
          {t("paymentDetails.cardForm.payNow")}
        </Button>
      )}
    </>
  );
};

export default PaymentForm;
